import { gql } from '@apollo/client';
import { JobFamilyGroupModel } from '@utmost.co/enterprise-models';

export interface JobFamilyGroup
  extends Pick<JobFamilyGroupModel, 'name' | 'referenceId' | 'status' | 'uid' | 'permissions'> {}
export interface UseGetAllJobFamilyGroupData {
  jobFamilyGroups: {
    jobFamilyGroups: JobFamilyGroup[];
  };
}

export const GET_ALL_JOB_FAMILY_GROUP_DATA = gql`
  query GET_ALL_JOB_FAMILY_GROUP_DATA($search: String, $limit: Int!, $offset: Int!) {
    jobFamilyGroups(query: { search: $search }, page: { limit: $limit, offset: $offset }) {
      totalCount
      limit
      offset
    }
  }
`;

export const GET_JOB_FAMILY_GROUPS = gql`
  query GET_JOB_FAMILY_GROUPS($query: JobFamilyGroupQueryModelInput, $page: PageModelInput) {
    jobFamilyGroups(query: $query, page: $page) {
      items {
        name
        referenceId
        uid
        permissions
      }
      offset
      totalCount
    }
  }
`;

export const REMOVE_JOB_FAMILY_GROUP = gql`
  mutation REMOVE_JOB_FAMILY_GROUP($uid: String!) {
    deleteJobFamilyGroup(uid: $uid) {
      uid
    }
  }
`;
